/*
 * Module for the New Benefits Estimate page
*/
rs.module("ui/content/communications/onlineforms/requestservicepurchase",

    [
        "common/select-helper",
        "controls/components/event-banner",
    ],

    function (selectHelper, eventBanner) {
        // Initialize the module
        function initialize(jsSelectors) {

            // Unpack Js Selectors
            var selectedPurchaseEstimateRadio = $.js(jsSelectors.selectedPurchaseEstimateRadio, { required: false, multiple: true });

            // Handle radio selection styles
            selectedPurchaseEstimateRadio.change(function () {
                // Remove highlight from all rows
                selectedPurchaseEstimateRadio.closest('tr').removeClass('selected-row');

                // Add highlight to this one
                $(this).closest('tr').addClass('selected-row');
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);